/**
 * Synthèse de l'accueil administrateur (UX, inventaire du 30/10/2026 §7.3 prio 4) : quatre groupes lisibles d'un coup
 * d'œil, qui filtrent ensuite le pipeline. Les dossiers refusés et archivés n'entrent dans aucun groupe.
 */
import type { SousStatut } from "./statuts";

export type GroupeSynthese = "a_valider" | "financement" | "formation" | "paiement";

export const GROUPES_SYNTHESE: ReadonlyArray<{ cle: GroupeSynthese; libelle: string; detail: string; sous_statuts: readonly SousStatut[] }> = [
  { cle: "a_valider", libelle: "À valider", detail: "dossiers soumis par les formateurs", sous_statuts: ["en_cours_validation"] },
  { cle: "financement", libelle: "En financement", detail: "validés, en attente de l'accord", sous_statuts: ["dossier_valide", "dossier_depose"] },
  { cle: "formation", libelle: "En formation", detail: "de l'accord à la fin de la formation", sous_statuts: ["accord_financement", "envoi_elements_pedagogiques", "formation_debutee", "fin_dossier_incomplet"] },
  { cle: "paiement", libelle: "Paiement", detail: "complets, facturés ou encaissés", sous_statuts: ["fin_dossier_complet", "demande_paiement", "paiement_receptionne"] },
];

export function groupeDe(s: SousStatut): GroupeSynthese | null {
  return GROUPES_SYNTHESE.find((g) => g.sous_statuts.includes(s))?.cle ?? null;
}

export function compterParGroupe(statuts: readonly SousStatut[]): Record<GroupeSynthese, number> {
  const r: Record<GroupeSynthese, number> = { a_valider: 0, financement: 0, formation: 0, paiement: 0 };
  for (const s of statuts) {
    const g = groupeDe(s);
    if (g) r[g] += 1;
  }
  return r;
}
